/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VersionSyncInfo { 
    /**
     * Org Id of entity passed in request body to check for validations.
     */
    org_id: string;
    /**
     * Deployment Id of entity passed in request body to check for validations.
     */
    deployment_id: string;
    /**
     * Current Db version
     */
    current_version: any | null;
    /**
     * Current Db version Updated or Not.
     */
    version_updated: boolean;
}

